import React from 'react';
import { useIntl } from 'umi';
import PlatformSelector from '@intelligence/components/TeaSelector/GooglePlatform';
import { renderOptionSummary } from '../previewHelpers';
import { getStringArrayValue } from '../shared/valueUtils';
import { FILTER_TYPE } from '../filterTypes';

import type { IFilterRenderProps, IFilterTypeEntry } from '@intelligence/v3/filterCore/registry';
import type { IFilterControlModule, IFilterPreviewContext } from '../controlModule';
import type { IPlatformFilterValue } from './types';

const PlatformRenderer: React.FC<IFilterRenderProps<IPlatformFilterValue>> = (props) => {
  const { field, value, onChange, ...rest } = props;

  return (
    <PlatformSelector
      {...rest}
      key={field}
      value={getStringArrayValue(value)}
      onConfirm={(payload: string[]) => {
        onChange(payload);
      }}
    />
  );
};

const PlatformPreview: React.FC<{
  valueItem: any;
  platformOptions: any[];
}> = (props) => {
  const { valueItem, platformOptions } = props;
  const { locale, formatMessage } = useIntl();

  return (
    <>
      <span className="model-form-text">{formatMessage({ id: 'dbi_platform' })}</span>
      <span className="model-form-context">{renderOptionSummary(valueItem, platformOptions, formatMessage, locale)}</span>
    </>
  );
};

const getRenderPreview = (ctx: IFilterPreviewContext): NonNullable<IFilterTypeEntry['renderPreview']> => {
  const { platformOptions = [] } = ctx;

  // eslint-disable-next-line react/display-name
  return (_item, value) => <PlatformPreview valueItem={value} platformOptions={platformOptions} />;
};

export const platformControl: IFilterControlModule = {
  type: FILTER_TYPE.PLATFORM,
  entry: {
    render: (props) => {
      return <PlatformRenderer {...props} />;
    },
  },
  getRenderPreview,
};
